/**
 * Mock data utilisé si VITE_USE_MOCKS=true.
 * Persona test : Marie Dupont — coach business solo Lyon, pack Growth.
 * Aligné avec les rows seedées en DB Supabase (id 44444444-...).
 */

export const mockKpis = {
  ca_jour_eur: 2800, // 1 client signed today @ Marie's pricing
  ca_jour_variation: 22.4,
  orders_jour: 1,
  leads_jour: 14, // prospects LinkedIn entrants
  reach_24h: 3200, // reach Instagram + LinkedIn
  engagement_median_pct: 4.8,
  anthropic_budget_used: 0.11, // coût agents 24h pour 1 client Growth
  anthropic_budget_max: 6,
  approvals_pending_count: 3, // prospection + email follow-up + newsletter
};

export const mockApprovals = [
  {
    id: '88888881-8888-8888-8888-888888888888',
    agent_name: 'LIV-02 — Prospection LinkedIn',
    output_type: 'linkedin_messages',
    content: `20 messages LinkedIn personnalisés pour ICP "Dirigeantes 35-45 ans, CEO/COO de SaaS B2B 2-10M ARR, basées France".

Aperçu — message 1 (Camille Renard, CEO @ FlowMetrics) :
"Camille, j'ai vu ton post sur la transition CEO solo → équipe de 12. Le passage 8→12 c'est exactement le moment où la plupart des fondatrices que j'accompagne se grillent en 6 mois. Si t'es ouverte, je partage 2 patterns que j'ai vus marcher (15 min, sans pitch). Marie"

Aperçu — message 2 (Léa Beaumont, COO @ DataStack) :
"Léa, ton intervention au podcast Maddyness sur la rentabilité avant la croissance — pile mon credo. Je coache 8 dirigeantes de SaaS qui font 3-15M ARR sur ces sujets. Café virtuel pour échanger ? Marie"

Volume total : 20 messages personnalisés
Estimation taux de réponse : 12-18%`,
    recipient: 'linkedin',
    metadata: { production_id: '77777772', icp: 'dirigeantes_saas_2_10m', messages_count: 20 },
    created_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: '88888882-8888-8888-8888-888888888888',
    agent_name: 'LIV-04 — Email Follow-up',
    output_type: 'email_followup',
    content: `Email follow-up — Antoine Vernet (silence 5j sur action plan)

Sujet : Antoine — quick check-in

Antoine,

Quick check-in : tu en es où sur l'action de définir tes 3 priorités Q2 ?

Si tu butes, dis-moi quelle question tu te poses, on la débloque ensemble en 10 min lundi.

Marie

Ton : warm_low_pressure · 38 mots`,
    recipient: 'antoine.vernet@example.com',
    metadata: { production_id: '77777773', trigger: 'client_no_response_5d' },
    created_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: '88888883-8888-8888-8888-888888888888',
    agent_name: 'PRD-05 — Newsletter Coach',
    output_type: 'newsletter',
    content: `Newsletter avril 2026 — 8 clients actifs + 47 prospects warm

Sujet : [Marie] La règle du 80/20 que j'ai cassée ce mois-ci
Préheader : Et pourquoi ça change tout pour ton scale

Salut [first_name],

Ce mois, j'ai fait une chose que j'aurais juré ne jamais faire : j'ai viré 2 clients.

Pas parce qu'ils étaient mauvais. Parce qu'ils me coûtaient 80% de mon énergie pour 20% de mon CA.

La règle 80/20 inversée — celle qu'on n'ose pas appliquer à ses propres clients.

Je te raconte le contexte, le calcul, et le résultat (spoiler : +18k€/mois après).

[Lire l'article complet →]

À la semaine prochaine,
Marie

Estimation taux d'ouverture : 32% · 142 mots`,
    recipient: 'newsletter_subscribers',
    metadata: { production_id: '77777775', edition: 'avril_2026', estimated_open: '32%' },
    created_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
  },
];

export const mockScripts = [
  // Pilier PRICING
  { id: 's1', pilier: 'pricing', title: "Pourquoi tu n'oses pas demander 3000€/mois", hook: "Tu factures 600€/mois alors que tu pourrais en demander 3000...", duration_s: 45, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 5, published_count: 1 },
  { id: 's2', pilier: 'pricing', title: "Le pricing premium en 3 étapes", hook: "Casser le plafond de pricing, c'est d'abord un travail intérieur...", duration_s: 35, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 5, published_count: 0 },
  { id: 's3', pilier: 'pricing', title: "80% restent quand le prix monte", hook: "Tu crois que tes clients vont fuir si tu doubles ton tarif...", duration_s: 30, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: false, scheduled_count: 0, published_count: 0 },
  // Pilier SCALE
  { id: 's11', pilier: 'scale', title: "La règle du 80/20 inversée", hook: "Vire 20% de tes clients. Récupère 80% de ton énergie...", duration_s: 40, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 5, published_count: 2 },
  { id: 's12', pilier: 'scale', title: "Passer de coach 1-1 à 1-many sans perte de qualité", hook: "Tu peux coacher 30 personnes en groupe avec plus d'impact...", duration_s: 35, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: false, scheduled_count: 0, published_count: 0 },
  // Pilier MINDSET
  { id: 's21', pilier: 'mindset', title: "Le syndrome de l'imposteur du coach solo", hook: "Si tu te sens illégitime à 5 ans d'expérience, écoute ça...", duration_s: 45, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 4, published_count: 1 },
  { id: 's22', pilier: 'mindset', title: "Pourquoi tu n'envoies pas tes prix par mail", hook: "Tu hésites à mettre tes prix dans tes emails de prospection...", duration_s: 30, status: 'draft' as 'approved' | 'draft' | 'archived', has_variants: false, scheduled_count: 0, published_count: 0 },
  // Pilier CASE-STUDY
  { id: 's31', pilier: 'case_study', title: "Comment Sophie est passée de 600€ à 1500€/mois", hook: "Sophie coachait 4 clients à 600€. En 30 jours...", duration_s: 60, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 3, published_count: 3 },
  // Pilier METHODE
  { id: 's41', pilier: 'methode', title: "Le framework des 3 priorités Q2", hook: "Si t'as plus de 5 priorités, t'en as zéro...", duration_s: 30, status: 'approved' as 'approved' | 'draft' | 'archived', has_variants: true, scheduled_count: 5, published_count: 0 },
];

// Calendar : 8 semaines de publications
export const mockCalendar = (() => {
  const items: Array<{
    date: string;
    platform: string;
    pilier: string;
    title: string;
    status: 'pending' | 'published' | 'failed';
  }> = [];
  const start = new Date('2026-05-04T00:00:00Z');
  const platforms = ['linkedin', 'instagram', 'tiktok', 'threads', 'youtube_shorts'];
  const titles: Record<string, string[]> = {
    pricing: ["Pourquoi tu n'oses pas 3000€/mois", "Le pricing premium en 3 étapes", "80% restent quand le prix monte"],
    scale: ["La règle 80/20 inversée", "Coach 1-many sans perte qualité"],
    mindset: ["Syndrome imposteur du coach solo", "Pourquoi tu n'envoies pas tes prix"],
    case_study: ["Sophie 600€ → 1500€/mois", "Antoine 3 priorités Q2"],
    methode: ["Framework 3 priorités Q2", "Onboarding client en 1 call"],
  };
  const piliers = Object.keys(titles);
  for (let day = 0; day < 56; day++) {
    const d = new Date(start);
    d.setUTCDate(start.getUTCDate() + day);
    if (d.getUTCDay() === 0) continue; // skip dimanche
    const pilier = piliers[day % piliers.length]!;
    const title = titles[pilier]![day % titles[pilier]!.length]!;
    for (const platform of platforms) {
      items.push({
        date: d.toISOString().slice(0, 10),
        platform,
        pilier,
        title,
        status: day < 14 ? 'published' : 'pending',
      });
    }
  }
  return items;
})();

// Finance : 12 mois pour Marie (CA 28k au mois 1, ramp jusqu'à ~75k au mois 12)
export const mockFinance = {
  monthly: Array.from({ length: 12 }, (_, i) => {
    const month = new Date(2026, 4 + i, 1).toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' });
    const ca = Math.round(28000 * Math.pow(1.085, i)); // +8.5%/mois
    const costs = Math.round(3200 + i * 180);
    return { month, ca_eur: ca, costs_eur: costs, profit_eur: Math.round(ca * 0.78 - costs) };
  }),
  channels: [
    { name: 'Coaching 1-1 Premium', value: 14400 }, // 8 clients × 1500€/mois × 0.6 récurrent
    { name: 'Programme Scale 90j', value: 8500 },
    { name: 'Mentorat Group (10 places)', value: 4500 },
    { name: 'Workshops trimestriels', value: 2800 },
    { name: 'Newsletter sponsoring', value: 800 },
  ],
};

// System : circuits + logs récents
export const mockSystem = {
  circuits: [
    { service: 'anthropic', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'linkedin_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'gmail_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'calendly_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'notion_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'crm_api', state: 'half_open' as 'closed' | 'open' | 'half_open', failure_count: 3 },
    { service: 'instagram_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
    { service: 'tiktok_api', state: 'closed' as 'closed' | 'open' | 'half_open', failure_count: 0 },
  ],
  recent_errors: [
    {
      id: 'log_1',
      agent_name: 'LIV-02',
      model: 'claude-sonnet-4-6',
      error: 'LinkedIn API: rate limit (resume in 18 min)',
      timestamp: new Date(Date.now() - 18 * 60 * 1000).toISOString(),
    },
    {
      id: 'log_2',
      agent_name: 'LIV-04',
      model: 'claude-haiku-4-5-20251001',
      error: 'CRM webhook timeout (retry queued)',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    },
  ],
  budget: {
    daily_used_usd: 0.11,
    daily_max_usd: 6,
    last_24h_calls: 12,
    last_24h_avg_cost_usd: 0.0092,
  },
};

// Settings : prompts du registry pour les 5 agents Growth de Marie
export const mockPrompts = [
  {
    name: 'cr-session-generator',
    version: 2,
    model_target: 'claude-sonnet-4-6',
    description: 'CR de session coaching automatique post-call (LIV-01)',
    is_active: true,
    excerpt: "Tu rédiges un compte-rendu de session de coaching business (60 min). Inputs : transcript audio, notes manuelles, profil client...",
  },
  {
    name: 'linkedin-prospection',
    version: 3,
    model_target: 'claude-sonnet-4-6',
    description: 'Messages LinkedIn personnalisés pour ICP (LIV-02)',
    is_active: true,
    excerpt: "Tu génères 20 messages LinkedIn pour un coach business solo, basé sur l'ICP fourni. Ton : sans pitch, contextualise un signal...",
  },
  {
    name: 'email-followup',
    version: 1,
    model_target: 'claude-haiku-4-5-20251001',
    description: 'Relance email douce (LIV-04)',
    is_active: true,
    excerpt: "Tu relances un client coaching qui n'a plus répondu depuis X jours. Ton : warm_low_pressure, 30-50 mots max, propose une porte de sortie...",
  },
  {
    name: 'reel-generator',
    version: 2,
    model_target: 'claude-haiku-4-5-20251001',
    description: 'Scripts reels/carrousels (PRD-04)',
    is_active: true,
    excerpt: "Tu écris un script de reel pour un coach business solo. Format : carousel 5 slides ou hook+body. Pilier au choix : pricing, scale, mindset, case_study, methode...",
  },
  {
    name: 'newsletter-generator',
    version: 1,
    model_target: 'claude-sonnet-4-6',
    description: 'Newsletter mensuelle (PRD-05)',
    is_active: true,
    excerpt: "Tu rédiges la newsletter mensuelle d'un coach business pour son audience clients + warm prospects. Sujet : 1 prise de position forte du mois...",
  },
];

// Liste des clients (admin)
export const mockClientsAdmin = [
  {
    id: '44444444-4444-4444-4444-444444444444',
    company_name: 'Coach Marie Dupont',
    contact_email: 'sebastian.stephen.dominguez@gmail.com',
    niche: 'coach_business_solo',
    status: 'active',
    health_status: 'green',
    plan_tier: 'growth',
    mrr_eur: 0,
    schema_isolation: 'marie_dupont',
    started_at: '2026-04-20',
  },
];

// Les 5 agents personnalisés Marie Dupont (pack Growth)
export const mockAgents = [
  {
    name: 'LIV-01 — CR Session Auto',
    description: 'Compte-rendu auto post-session coaching (3h/sem économisées)',
    last_run_at: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString(),
    last_run_status: 'success' as 'success' | 'error' | 'timeout' | 'skipped',
    runs_24h: 0,
    success_rate_24h: 100,
    circuit_state: 'closed' as 'closed' | 'open' | 'half_open',
  },
  {
    name: 'LIV-02 — Prospection LinkedIn',
    description: 'Messages perso pour ICP dirigeantes SaaS (4h/sem)',
    last_run_at: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    last_run_status: 'success' as 'success' | 'error' | 'timeout' | 'skipped',
    runs_24h: 1,
    success_rate_24h: 100,
    circuit_state: 'closed' as 'closed' | 'open' | 'half_open',
  },
  {
    name: 'LIV-04 — Email Follow-up',
    description: "Relances clients silencieux (3h/sem)",
    last_run_at: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    last_run_status: 'success' as 'success' | 'error' | 'timeout' | 'skipped',
    runs_24h: 4,
    success_rate_24h: 100,
    circuit_state: 'closed' as 'closed' | 'open' | 'half_open',
  },
  {
    name: 'PRD-04 — Reels Generator',
    description: '3 scripts reels/semaine sur tes 5 piliers (3h/sem)',
    last_run_at: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    last_run_status: 'success' as 'success' | 'error' | 'timeout' | 'skipped',
    runs_24h: 0,
    success_rate_24h: 100,
    circuit_state: 'closed' as 'closed' | 'open' | 'half_open',
  },
  {
    name: 'PRD-05 — Newsletter Coach',
    description: 'Newsletter mensuelle clients + prospects warm (2h/mois)',
    last_run_at: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    last_run_status: 'success' as 'success' | 'error' | 'timeout' | 'skipped',
    runs_24h: 1,
    success_rate_24h: 100,
    circuit_state: 'closed' as 'closed' | 'open' | 'half_open',
  },
];
